const environment = {
  baseUrl: "https://sigap.kehutanan.go.id/tatakelola/new/", //"http://localhost:3000",
  api: "https://sigap.kehutanan.go.id/tatakelola/api-new/api", //"http://localhost:8080/api",
  geoserverLocal: "http://172.16.3.163:8081/",
};

if (process.env.REACT_APP_ENV === "development") {
  environment.baseUrl = "http://dev.techlab.id";
}

if (process.env.REACT_APP_ENV === "staging") {
  environment.baseUrl = "http://sta.techlab.id";
}

if (process.env.REACT_APP_ENV === "production") {
  environment.baseUrl = "http://prod.techlab.id";
}

export default environment;
